module.exports = __webpack_public_path__ + "static/media/step_010.d072d2d7.jpeg";